/** Préférence d’environnement LyrraOne (compte perso vs équipe invitée). */

export type LoWorkspaceMode = 'own' | 'team';

const STORAGE_KEY = 'lyrraone-active-workspace';

export function getLoWorkspaceMode(): LoWorkspaceMode {
  if (typeof window === 'undefined') return 'team';
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return raw === 'own' || raw === 'team' ? raw : 'team';
}

export function setLoWorkspaceMode(mode: LoWorkspaceMode): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, mode);
}

export const LO_WORKSPACE_HEADER = 'X-Lo-Workspace';
